import React from 'react';
import PropTypes from 'prop-types';
import CustomPageDetailContentWrapper from './CustomPageDetailContentWrapper';

import {DateUtil, ArrayUtil} from '@aperza/util';

const CustomPageDetailContentNews = (props) => {

  let {
    pageBlock = {},
  } = props;

  let {
    pageBlockItems = [],
  } = pageBlock;

  const renderContentTag = (contentTags = []) => {
    if (ArrayUtil.isEmpty(contentTags)) return undefined;
    return contentTags.map((tag, index) => {
      return (
        <span key={index} className={tag.contentTagClass} >{tag.contentTagName}</span>
      )
    })
  };

  const renderRows = () => {
    return pageBlockItems.map((pageBlockItem, index) => {
      let date = DateUtil.parse(pageBlockItem.extendProperties.publishDatetime);
      return (
        <div key={index} className={'custompage-news-item'}>
          <div className={'custompage-news-publishdatetime'}>
            {DateUtil.format(date,'YYYY年M月D日')}
          </div>
          <div className={'custompage-news-cat-tag'}>{renderContentTag(pageBlockItem.extendProperties.contentTags)}</div>
          <div className={'custompage-news-title'}>
            { pageBlockItem.itemOpenLinkType != 'NO_LINK' &&
              <a href={pageBlockItem.itemUrl} target={ pageBlockItem.itemOpenLinkType == 'SAME_WINDOW' ? '_self' : '_blank' }>
                <span>{pageBlockItem.itemName}</span>
              </a>
            }
            { pageBlockItem.itemOpenLinkType == 'NO_LINK' &&
              <span>{pageBlockItem.itemName}</span>
            }
          </div>
        </div>
      )
    })
  };

  return (
    <CustomPageDetailContentWrapper pageBlock={pageBlock}>
      <div className={'CustomPageNewsList'}>
        {renderRows()}
      </div>
    </CustomPageDetailContentWrapper>
  );
}

CustomPageDetailContentNews.propTypes = {
  pageBlock: PropTypes.any.isRequired
};

export default CustomPageDetailContentNews;
